import Model from "../model";
import request from "../../request/request";
import { QuestionDimension } from "./dimension-v2";
import { ScoreRole, ScoreRoleMap } from "./score-role";
import Auth from "@/lib/common/auth";
import { StructExamScoreConfig } from "./exam-v2";
import { getDimensionColor } from "@/lib/dimension/dimension-color";
import { BlankQuestionAnswer } from "../exam/candidate-answer";
import AppendAskConfig from "./inquiry";

class BlankQuestionConfig extends Model {
  scoreType = 3; // 评分类型 1全对满分否则0分 2按答对比例得分 3每空单独计分
  answerList: BlankQuestionAnswer[] = [new BlankQuestionAnswer()]; // 每个空的答案列表 至少存在一项
  ignoreBlank = 1; // 是否忽略答案首尾空白
  strictOrder = 1; // 是否顺序严格
}

export enum EnumQuestionType {
  EnumQuestionTypeSingleChoice = 1, // 单选
  EnumQuestionTypeMultipleChoice = 2, // 多选 隐藏
  EnumQuestionTypeJudge = 3, // 判断 被单选代替
  EnumQuestionTypeQA = 4, // 问答 隐藏
  EnumQuestionTypeBlanks = 5, // 填空 配置
  EnumQuestionTypeVideo = 6, // 视频问答
  EnumQuestionTypeNewSingleChoice = 7, // 测评单选 类单选
  EnumQuestionTypeMP3 = 8, // 音频题
  EnumQuestionTypeLocation = 101, // 通勤时间 配置+测评单选
  EnumQuestionTypeColor = 102, // 颜色识别 测评类型
  EnumQuestionTypeVideoSquat = 103, // 蹲起检测 类视频问答 测评类型
  EnumQuestionTypeVideoBody = 104, // 形体检测 类视频问答 测评类型
  EnumQuestionTypePsychological = 105, // fsk心理检测 子选择题列表 测评类型
  EnumQuestionTypePsyc = 106, // 通用心理检测 子选择题列表 测评类型 报告类型
  EnumQuestionTypeGame = 107 // 通用游戏测评 测评类型 报告类型
}

export class Option extends Model {
  optionKey = ""; // 选项key A/B/C/D
  content = ""; // 选项内容
  defaultScorePercent: number | undefined = 0; // 默认分数百分比 <=100%

  // 不需要传后端
  showScoreErr = false;
  showContentErr = false;
  showFocus = false;
}

export class QuestionCustom extends Model {
  questionType: EnumQuestionType =
    EnumQuestionType.EnumQuestionTypeNewSingleChoice; // 题型
  desc = ""; // 题干富文本
  descTextOnly = "";
  remark = ""; // 备注
  dimensionKeyList: string[] = [""]; // 维度键 视频1-4项 单选1项 填空1项
  scoreRuleList = [new ScoreRoleMap()]; // 视频题-评分规则
  referenceAnswer = ""; // 视频题-参考答案
  optionList: Option[] = [
    new Option(),
    new Option(),
    new Option(),
    new Option()
  ]; // 单选题-选项
  questionPositionId = 0; // 岗位id
  questionIndustryId = 0; // 行业id
  language = ""; // 语言  zh en
  appendDesc = ""; // 补充阅读材料
  appendDescTextOnly = "";
  blankQuestionConfig = new BlankQuestionConfig(); // 填空题配置
  isAiQuestion = 2; // 是否是AI题目
  needTranslate = 2; // 是否需要翻译(需要英语回答题)

  getQuestionTypeText() {
    switch (this.questionType) {
      case EnumQuestionType.EnumQuestionTypeVideo:
      case EnumQuestionType.EnumQuestionTypeVideoBody:
        return "视频题";
      case EnumQuestionType.EnumQuestionTypeNewSingleChoice:
      case EnumQuestionType.EnumQuestionTypeSingleChoice:
        return "选择题";
      case EnumQuestionType.EnumQuestionTypeMP3:
        return "音频题";
      case EnumQuestionType.EnumQuestionTypeBlanks:
        return "填空题";
    }
  }

  isVideoQuestion() {
    return (
      this.questionType === EnumQuestionType.EnumQuestionTypeVideo ||
      this.questionType === EnumQuestionType.EnumQuestionTypeVideoBody ||
      this.questionType === EnumQuestionType.EnumQuestionTypeVideoSquat
    );
  }

  isSingleSelect() {
    return (
      this.questionType === EnumQuestionType.EnumQuestionTypeSingleChoice ||
      this.questionType === EnumQuestionType.EnumQuestionTypeNewSingleChoice
    );
  }

  isMP3() {
    return this.questionType === EnumQuestionType.EnumQuestionTypeMP3;
  }
  isBlank() {
    return this.questionType === EnumQuestionType.EnumQuestionTypeBlanks;
  }
}
enum EnumBool {
  EnumBoolOptionUndefined = 0, // 创建修改:未定义、默认 使用判断:关、否
  EnumBoolOptionOn = 1, // 开、是
  EnumBoolOptionOff = 2 // 关、否
}

export class QuestionV2 extends QuestionCustom {
  questionId = 0; // 题目id
  companyId = 0; // 公司id
  isSystemQuestion: EnumBool = 0; // 是否是系统默认题目
  isAiQuestion: EnumBool = 0; // 视频题-是否是ai题目
  isExamUsed: EnumBool = 0; // 是否被面试使用中
  hasDimension: EnumBool = 0; // 是否有维度配置
  hasScoreRule: EnumBool = 0; // 视频题-是否有评分规则
  scoreRuleStatus = 0; // 评分规则状态
  dimensionListOrigin: QuestionDimension[] = [new QuestionDimension()]; // 题目维度列表-全量
  dimensionListFilter: QuestionDimension[] = [new QuestionDimension()]; // 题目维度列表-过滤
  selected = false;
  audioDescUrl = ""; // 听力材料链接
  audioDescFilename = ""; // 听力材料文件名
  audioDescDuration = 0; // 听力材料时长
  audioDescPlayTimeLimit = 0; // 听力材料播放次数限制
  isAudioDescAutoPlay = 0; // 听力材料是否读题后自动播放
  isAudioDescMustPlay = 0; // 听力材料是否强制播放
  isAudioDescForbidPause = 0; // 听力材料是否禁止暂停
  isAppendAsk: EnumBool = 0; // 是否追问 0:不筛选 1:是追问 2:非追问
  appendAskConfig: AppendAskConfig = new AppendAskConfig();
  questionIndustryId = 0; // 行业id
  questionPositionId = 0; // 岗位id
  questionPositionName = ""; // 岗位名称
  questionIndustryName = ""; // 行业名称
  vipLevel = 0; // vip等级 0免费 10付费
  ownerStatus = 0; //题目类型 10公有题库 20私有题库
  blankQuestionConfig = new BlankQuestionConfig(); // 填空题配置
  hasReadText = 0; // 是否是朗读题

  // 后端不需要以下字段
  structExamScoreConfigList: StructExamScoreConfig[] = [];
  totalScore = 0;

  canEdit() {
    return (
      this.isSystemQuestion !== 1 ||
      (this.isVideoQuestion() && this.isAiQuestion !== 1)
    );
  }

  canDelete() {
    return this.isExamUsed !== 1 && this.isSystemQuestion !== 1;
  }

  //查询某个视频题下有多少有效答案
  getAnswerNumber() {
    return request
      .post("/aiExam/question2/answerNumber", { questionId: this.questionId })
      .then(resp => {
        return resp.data.data.answerNumber;
      });
  }

  get firstFilterDimension() {
    return this.dimensionListFilter[0];
  }
}

export class QuestionV2Object extends Model {
  list: QuestionV2[] = [new QuestionV2()];
  count = 0;

  //获取题库试题List
  static get(params: any, url = "aiExam/question2/list") {
    params.companyId = Auth.companyId;
    if (params.pageSize == undefined) params.pageSize = 100;
    return request.post(url, params).then(resp => {
      const qo = new QuestionV2Object(resp).assign(resp.data.data);
      qo.list = qo.list.map(q => {
        q.optionList = QuestionV2Object.filterOption(q.optionList);
        return q;
      });
      return qo;
    });
  }

  static tacGet(params: any, tacToken: string) {
    return request
      .post("tac/template/redirect", {
        path: "/aiExam/question2/list",
        tacToken,
        request: params
      })
      .then(resp => {
        const qo = new QuestionV2Object(resp).assign(resp.data.data);
        qo.list = qo.list.map(q => {
          q.optionList = QuestionV2Object.filterOption(q.optionList);
          return q;
        });
        return qo;
      });
  }

  static exportByExam(params: any) {
    return request
      .postInterviewApi("/hr/question/exportByExam", params)
      .then(resp => {
        return resp.data;
      });
  }

  static exportByIds(params: any) {
    return request
      .postInterviewApi("/hr/question/exportById", params)
      .then(resp => {
        return resp.data;
      });
  }

  static exportTemplate() {
    return request.postInterviewApi("/hr/question/exportEmpty").then(resp => {
      return resp.data;
    });
  }

  static importByUrl(params: { excelUrl: string }) {
    return request
      .postInterviewApi("/hr/question/import", params)
      .then(resp => {
        return resp.data;
      });
  }

  static delete(questionId: any) {
    const params = {
      questionId: questionId,
      companyId: Auth.companyId
    };
    return request.post("/aiExam/question2/delete", params).then(resp => {
      const qo = new QuestionV2Object(resp).assign(resp.data.data);
      qo.list = qo.list.map(q => {
        q.optionList = QuestionV2Object.filterOption(q.optionList);
        return q;
      });
      return qo;
    });
  }

  static update(questionId: any, question: QuestionCustom) {
    let params = {
      questionId: questionId,
      companyId: Auth.companyId
    };
    params = Object.assign(params, question);
    return request.post("/aiExam/question2/update", params).then(resp => {
      const question = new QuestionV2().assign(resp.data.data);
      question.optionList = QuestionV2Object.filterOption(question.optionList);
      return question;
    });
  }

  static create(question: QuestionCustom) {
    let params = {
      companyId: Auth.companyId
    };
    params = Object.assign(params, question);
    return request.post("/aiExam/question2/create", params).then(resp => {
      const question = new QuestionV2().assign(resp.data.data);
      question.optionList = QuestionV2Object.filterOption(question.optionList);
      return question;
    });
  }
  // 处理选择题选项
  static filterOption(optionList: Option[]): Option[] {
    const list = optionList.filter(option => option._isAssignedFlag);
    return list;
  }
}
